import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const articlesSliderBlocks = document.querySelectorAll('.microsite-articles-slider-block') as NodeListOf<HTMLElement>

const initArticlesSliders = () => {
    if (articlesSliderBlocks.length > 0)
    {
        articlesSliderBlocks.forEach(slider => {
            const splideElement = slider.querySelector('.splide') as HTMLElement

            if (splideElement)
            {
                new Splide(splideElement, {
                    fixedWidth: '90%',
                    gap: '16px',
                    mediaQuery: 'min',
                    breakpoints: {
                        900: {
                            gap: '24px'
                        },
                        1113: {
                            gap: '48px'
                        }
                    }
                }).mount()
            }
        })
    }
}

export function initSlideshows() {
    initArticlesSliders()
}

const heroSliderBlocks = document.querySelectorAll('.microsite-hero-block') as NodeListOf<HTMLElement>

const initHeroSlider = () => {
    if (heroSliderBlocks.length > 0)
    {
        heroSliderBlocks.forEach(slider => {
            const splideElement = slider.querySelector('.splide') as HTMLElement

            if (splideElement)
            {
                new Splide(splideElement, {
                    
                    type         : 'loop',
                    perPage      : 1,
                    autoplay     : true,
                    interval     : 5000, 
                    pauseOnHover : true,
                    pauseOnFocus : false,
                    resetProgress: false,
                    arrows: true,
                    pagination: true
                }).mount()
            }
        })
    }
}

export function initHero() {
    initHeroSlider()
}













const marqueeSliderBlocks = document.querySelectorAll('.microsite-marquee-block') as NodeListOf<HTMLElement>

const initMarqueeSlider = () => {
    if (marqueeSliderBlocks.length > 0)
    {
        marqueeSliderBlocks.forEach(slider => {
            const splideElement = slider.querySelector('.splide') as HTMLElement

            if (splideElement)
            {
                new Splide(splideElement, {

                    type    : 'loop',
                    focus    : 'center',
                    height   : 'auto',

                    perPage: 6,  // Behåller denna för att ha fler bilder synliga
                    fixedWidth: 'auto',
                    gap: '0rem',
                    autoScroll: {
                        speed: 1,
                    },
                    
                    // interval     : 5000,
                    // pauseOnHover : true,
                    // pauseOnFocus : false,
                    // resetProgress: false,
                    arrows: false,
                    pagination: false
                }).mount({ AutoScroll })
            }
        })
    }
}

export function initMarquee() {
    initMarqueeSlider()
}




// slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     arrows: false,
//     dots: false,
//     autoplaySpeed: 5000